import React, { useState, useEffect } from "react";
import { Box, createTheme, Stack, Typography, Grid } from "@mui/material";
import { useStateValue } from "../../StateProvider";
import { useNavigate, useParams } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import axios from "axios";

const EarningsPage = () => {
  const [upcomingEarnings, setUpcomingEarnings] = useState([]);
  const [{ token }] = useStateValue();
  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/market/upcoming-earnings?token=${token}`
      )
      .then((res) => {
        console.log("res", res?.data);
        let data = res?.data;
        let dates = [];
        data?.map((d) => {
          let found = false;
          dates?.map((t) => {
            if (t == d?.reportDate) {
              found = true;
            }
          });
          if (!found) {
            dates?.push(d?.reportDate);
          }
        });
        console.log("dates", dates);
        let array = [];
        dates?.map((date) => {
          let symbols = [];
          data?.map((d) => {
            if (d?.reportDate == date) {
              symbols?.push(d?.symbol);
            }
          });
          array.push({ reportDate: date, companies: symbols });
        });
        console?.log("array", array);
        setUpcomingEarnings(array);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <Box sx={{ padding: "20px", height: "98vh", overflowY: "scroll" }}>
      <Box
        sx={{
          padding: { xs: "10px 20px", sm: "10px 20px" },
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <CalendarMonthIcon sx={{ color: "fontPrimaryColor.main" }} />
        <Typography
          sx={{
            fontSize: "1.5rem",
            fontFamily: "public sans",
            fontWeight: "500",
            color: "fontPrimaryColor.main",
            textTransform: "uppercase",
            marginLeft: { xs: "10px", sm: "0" },
            wordSpacing: "5px",
          }}
        >
          Earnings Calendar
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "bgPrimary.main",
          minHeight: "60vh",
          marginTop: "30px",
          borderRadius: "8px",
          padding: "20px",
        }}
      >
        {upcomingEarnings &&
          upcomingEarnings?.map((uc) => (
            <Box
              sx={{
                borderBottom: "0.6px solid lightgray",
                marginBottom: "30px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                padding: "0 0 30px 0",
              }}
            >
              <Box
                sx={{
                  fontFamily: "public sans",
                  fontWeight: "500",
                  fontSize: "0.875rem",
                  color: "fontSecondaryColor.main",
                }}
              >
                {uc?.reportDate}
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gap: "30px",
                  //   flexWrap: "wrap",
                  gridTemplateColumns: {
                    xs: "45% 45%  ",
                    sm: "30% 30% 30% ",
                    md: "20% 20% 20% 20%",
                  },
                  width: "100%",
                }}
              >
                {uc?.companies?.map((c) => (
                  <SingleCompany symbol={c} />
                ))}
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default EarningsPage;

const SingleCompany = ({ symbol }) => {
  const [{ token }] = useStateValue();
  const [companyName, setCompanyName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${symbol}/quote?token=${token}`
      )
      .then((res) => {
        console.log(symbol, "pryce", res.data);
        setCompanyName(res?.data?.companyName);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Box>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "0.875rem",
          color: "fontPrimaryColor.main",
        }}
      >
        {symbol}
      </Box>
      <Box
        sx={{
          fontFamily: "public sans",
          fontWeight: "500",
          fontSize: "0.875rem",
          color: "fontPrimaryColor.main",
          color: "#2d79db",
          cursor: "pointer",
        }}
        onClick={() => navigate(`/complete__details/stock/${symbol}`)}
      >
        {companyName}
      </Box>
    </Box>
  );
};
